'use strict';

export default {
    methods: {
        seeMoreContent(element) {
            const content = element?.target.closest('[data-webinar-video-see-more]').querySelector('[data-webinar-video-see-more-content]');
            const contentToExpand = element?.target.closest('[data-webinar-video-see-more]');
            const seeMoreContainer = element?.target.closest('[data-webinar-video-see-more-button]');
            const maxHeight = content.clientHeight;

            Velocity(seeMoreContainer, {
                opacity: 0
            },
            {
                duration: 100,
                display: 'none'
            });

            Velocity(contentToExpand, {
                height: maxHeight
            },
            {
                complete: () => {
                    contentToExpand.style.height = 'auto';
                }
            });
        }
    }
};